export default "__VITE_ASSET__OzflRpW___"